if (!customElements.get('mc-gallery-navigation')) {
  customElements.define('mc-gallery-navigation', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.gallery.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.matches('input, textarea, select')) return;
        event.preventDefault();
        const slides = this.slides(), current = slides.findIndex(e => e.dataset.mediaId === this.gallery.dataset.currentMedia);
        const slide = slides[(Math.max(0, current) + (event.key === 'ArrowRight' ? 1 : -1) + slides.length) % slides.length];
        if (slide) this.gallery.setActiveMedia(slide.dataset.mediaId, false);
      }, options);
      this.addEventListener('click', event => {
        let button = event.target.closest('button[data-media]');
        if (button && event.detail > 0) button = this.nearestButton(event.clientX);
        if (button) this.gallery.setActiveMedia(button.dataset.media, false);
      }, options);
      this.addEventListener('touchend', event => {
        if (!event.target.closest('button[data-media]') || event.changedTouches.length !== 1) return;
        event.preventDefault();
        const button = this.nearestButton(event.changedTouches[0].clientX);
        if (button) this.gallery.setActiveMedia(button.dataset.media, false);
      }, { ...options, passive:false });
      this.viewer.addEventListener('slideChanged', event => this.update(event.detail.currentElement?.dataset.mediaId), options);
      this.mutations = new MutationObserver(() => this.refresh());
      this.mutations.observe(this.viewer.querySelector('.product__media-list'), { childList:true, subtree:true, attributes:true, attributeFilter:['hidden'] });
      this.mutations.observe(this.gallery, { attributes:true, attributeFilter:['data-current-media'] });
      this.refresh();
    }
    nearestButton(x) {
      return [...this.querySelectorAll('button')].reduce((nearest, candidate) => {
        const distance = node => Math.abs(node.getBoundingClientRect().left + node.offsetWidth / 2 - x);
        return !nearest || distance(candidate) < distance(nearest) ? candidate : nearest;
      }, null);
    }
    slides() { return [...this.viewer.querySelectorAll('.product__media-list > [data-media-id]')].filter(e => !e.hidden); }
    refresh() {
      const slides = this.slides();
      const signature = slides.map(e => e.dataset.mediaId).join('|');
      if (this.signature !== signature) {
        this.signature = signature;
        this.replaceChildren(...slides.map((slide, index) => {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.media = slide.dataset.mediaId;
          button.setAttribute('aria-label', this.dataset.label.replace('[index]', index + 1));
          button.setAttribute('aria-controls', this.viewer.slider.id);
          return button;
        }));
        this.style.setProperty('--mc-dot-count', slides.length);
        this.classList.toggle('mc-gallery-navigation--many', slides.length > 9);
      }
      this.update(this.gallery.dataset.currentMedia || slides[0]?.dataset.mediaId);
    }
    update(id) { this.querySelectorAll('button').forEach(e => e.setAttribute('aria-current', String(e.dataset.media === id))); }
    disconnectedCallback() { this.abort?.abort(); this.mutations?.disconnect(); }
  });
}
